// lỗi TPB bank trả về
export const dataErrorOCB = {
    // ["GeneralError"]: {text: "Đã có lỗi xảy ra. Bạn vui lòng liên hệ nhân viên để thử lại"},
    ["105101"]: {text: "Mã giao dịch của đối tác đã tồn tại"},
    ["105131"]: {text: "Kết nối OCB thất bại. Thông tin đầu vào không hợp lệ"},
    ["105151"]: {text: "Kết nối OCB thất bại. Thông tin xác thực không hợp lệ."},
    ["105132"]: {text: "Kết nối OCB thất bại. Chữ ký xác thực không đúng."},
    ["105133"]: {text: "Kết nối OCB thất bại. Lỗi hệ thống hoặc Timeout."},
    ["105135"]: {text: "Kết nối OCB thất bại. Giao dịch đang được Pending để đối soát."},
    ["105136"]: {text: "ClientID không có quyền sử dụng tài khoản nguồn."},
    ["105137"]: {text: "Số tiền vượt quá hạn mức/ngày"},
    ["105138"]: {text: "Số tiền vượt quá hạn mức/giao dịch"},
    ["105139"]: {text: "Số dư tài khoản không đủ để thực hiện giao dịch."},
    ["105141"]: {text: "Không tìm thấy thông tin giao dịch.",},
    ["105142"]: {text: "Tài khoản eBanking không hợp lệ.",},
    ["105143"]: {text: "Tài khoản thanh toán không hợp lệ."},
    ["105144"]: {text: "Số điện thoại không trùng với số điện thoại đăng ký"},
    ["105145"]: {text: "Giao dịch đã được hoàn tiền trước đó."},
    ["105146"]: {text: "Giao dịch bị Timeout hoăc không xác định."},
    ["105147"]: {text: "Giao dịch đã thất bại."},
    ["105148"]: {text: "Mã CIF hoặc Token không hợp lệ."},
    ["105149"]: {text: "Dịch vụ Facepay hiện không khả dụng.",},
    ["105152"]: {text: "Kết nối Facepay thất bại."},
    ["105153"]: {text: "Gói dịch vụ OCB OMNI không hợp lệ. Vui lòng nâng cấp gói với OCB trước khi thanh toán."},
    ["10"]: {text: "Khuôn mặt chưa được đăng ký"},
    ["21"]: {text: "Chưa kích hoạt dịch vụ FaceOTP"},
    ["43"]: {text: "Chưa kích hoạt dịch vụ FaceOTP"},
    ["-99"]: {text: "Không nhận được lỗi từ ngân hàng"},
    ["-100"]: {text: "Giao dịch chưa hoàn tất"},
    ["default"]: {text: "Giao dịch không thành công"},

}